// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"ebf5d3aa","202":"51d96a04","410":"debaa27d","506":"5e60e8d1","750":"7056b5b9","778":"c8d774b7"}[chunkId] + ".chunk.css";
};